import http from '@/services/http';
// eslint-disable-next-line import/no-cycle
import { advancedRevisionFilters } from '@/config';
import tableHelper from '@/services/tableHelper';

const CUSTOM_PARAMS = ['analysisId', 'accreditedTest', 'sampleReportStatus'];

function splitExtraWhere(extraWhere) {
  const customParams = {};
  const whereExtra = {};
  Object.entries(extraWhere).forEach(([key, value]) => {
    if (CUSTOM_PARAMS.includes(key)) {
      customParams[key] = value;
    } else {
      whereExtra[key] = value;
    }
  });
  return { customParams, whereExtra };
}

const advancedRevisionApi = {
  search(tableFilters, filterStatus, extraWhere = {}, config = {}) {
    const { customParams, whereExtra } = splitExtraWhere(extraWhere);
    const baseWhere = tableHelper.whereFilters(
      filterStatus,
      advancedRevisionFilters
    );
    const where =
      Object.keys(whereExtra).length > 0
        ? { and: [...(baseWhere.and || []), { or: [whereExtra] }] }
        : baseWhere;

    return http.request({
      method: 'get',
      url: '/admin/advanced-revision/search',
      params: { filter: { ...tableFilters, where }, ...customParams },
      ...config,
    });
  },

  getLabSample(labSampleId, config = {}) {
    return http.request({
      method: 'get',
      url: `/admin/advanced-revision/labsample/${labSampleId}`,
      ...config,
    });
  },

  getAnalyses(labSampleId, config = {}) {
    return http.request({
      method: 'get',
      url: `/admin/advanced-revision/analyses/${labSampleId}`,
      ...config,
    });
  },

  getTemperature(labSampleId, config = {}) {
    return http.request({
      method: 'get',
      url: `/admin/advanced-revision/temperature/${labSampleId}`,
      ...config,
    });
  },

  addTemperatureTrail(data, config = {}) {
    return http.request({
      method: 'post',
      url: '/admin/advanced-revision/temperature',
      data,
      ...config,
    });
  },

  deleteTemperatureTrail(temperatureTrailId, config = {}) {
    return http.request({
      method: 'delete',
      url: `/admin/advanced-revision/temperature/${temperatureTrailId}`,
      ...config,
    });
  },

  createDefaultRevision(labSampleId, data, config = {}) {
    return http.request({
      method: 'post',
      url: `/admin/advanced-revision/${labSampleId}/default`,
      data,
      ...config,
    });
  },

  searchCount(filterStatus, extraWhere = {}, config = {}) {
    const { customParams, whereExtra } = splitExtraWhere(extraWhere);
    const baseWhere = tableHelper.whereFilters(
      filterStatus,
      advancedRevisionFilters
    );
    const where =
      Object.keys(whereExtra).length > 0
        ? { and: [...(baseWhere.and || []), { or: [whereExtra] }] }
        : baseWhere;

    return http.request({
      method: 'get',
      url: '/admin/advanced-revision/count',
      params: { where, ...customParams },
      ...config,
    });
  },
};

export default advancedRevisionApi;
